export var MobileUnlockTiming;
(function (MobileUnlockTiming) {
    MobileUnlockTiming["Immediately"] = "immediately";
    MobileUnlockTiming["OnQuit"] = "on-quit";
})(MobileUnlockTiming || (MobileUnlockTiming = {}));
